import { comparisonData } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold uppercase tracking-wide mb-4">
              Comparison
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Superbuy Spreadsheet <span className="italic text-primary-500">vs</span> Manual Search
            </h2>
          </div>
          <p className="text-foreground-500 text-sm md:text-base max-w-md leading-relaxed">
            See why organized product research through Superbuy Spreadsheet delivers a dramatically better experience compared to traditional manual searching methods.
          </p>
        </div>

        {/* Three Column Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comparisonData.map((item, idx) => (
            <div
              key={item.title}
              className={`rounded-2xl overflow-hidden ${
                idx === 1
                  ? 'bg-foreground-950 text-background-50'
                  : 'bg-background-100'
              }`}
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`Superbuy Spreadsheet ${item.title}`}
                  title={`Superbuy Spreadsheet comparison - ${item.title}`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <span className={`inline-block px-3 py-1 rounded-lg text-xs font-semibold mb-3 whitespace-nowrap ${
                  idx === 1
                    ? 'bg-accent-500 text-foreground-950'
                    : 'bg-accent-100 text-accent-800'
                }`}>
                  {item.label}
                </span>
                <h3 className={`text-xl md:text-2xl font-heading font-bold mb-3 ${
                  idx === 1 ? 'text-background-50' : 'text-foreground-950'
                }`}>
                  {item.title}
                </h3>
                <p className={`text-sm leading-relaxed mb-4 ${
                  idx === 1 ? 'text-background-50/80' : 'text-foreground-500'
                }`}>
                  {item.description}
                </p>
                <div className="space-y-2">
                  {item.features.map((f) => (
                    <div key={f} className="flex items-center gap-2">
                      <div className={`w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 ${
                        idx === 1 ? 'bg-accent-400/30' : 'bg-accent-100'
                      }`}>
                        <i className={`ri-check-line text-[10px] font-bold ${
                          idx === 1 ? 'text-accent-400' : 'text-accent-700'
                        }`}></i>
                      </div>
                      <span className={`text-xs ${
                        idx === 1 ? 'text-background-50/80' : 'text-foreground-600'
                      }`}>{f}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}